import { render, staticRenderFns } from "./EmptySearch.vue?vue&type=template&id=6c6792f6&scoped=true&"
import script from "./EmptySearch.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmptySearch.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EmptySearch.vue?vue&type=style&index=0&id=6c6792f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6792f6",
  null
  
)

export default component.exports